module.exports = __webpack_public_path__ + "img/graph-up.2d9b8ce8.svg";